import {createTheme} from "@mui/material/styles";
import {themeName, breakpoints, spacing, palette, typography, shape, props} from './baseTheme'
import overrideTheme from './overrideTheme';

let theme = createTheme({themeName, breakpoints, spacing, palette, typography, shape, props});
theme = overrideTheme(theme);

export default theme;
